import { render, staticRenderFns } from "./smsRecord.vue?vue&type=template&id=14fd3286&scoped=true&"
import script from "./smsRecord.vue?vue&type=script&lang=js&"
export * from "./smsRecord.vue?vue&type=script&lang=js&"
import style0 from "./smsRecord.vue?vue&type=style&index=0&id=14fd3286&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14fd3286",
  null
  
)

export default component.exports